if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form
                    .querySelector("[name=id]")
                    ?.removeAttribute?.("disabled");
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );

                // gift card product - recipient form
                this.recipientForm = this.querySelector("recipient-form");
            }

            getSubmitButton() {
                var formId = this.form.getAttribute("id");

                return (
                    this.querySelector('[type="submit"]') ||
                    document.querySelector('[form="' + formId + '"]')
                );
            }

            getMessageWrapper() {
                this.messageWrapper =
                    this.messageWrapper ||
                    this.querySelector(".message-wrapper");

                if (this.messageWrapper) {
                    return this.messageWrapper;
                }

                this.messageWrapper = createFromTemplate("message-wrapper");
                this.getSubmitButton()?.after(this.messageWrapper);

                return this.messageWrapper;
            }

            getCartJson() {
                return fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).then((response) => response.json());
            }

            // Mojo Pro Shop: builds the multi-item payload for Bowling Balls
            // product pages that include the Professional Drilling / Grips /
            // Slug add-on options block (see snippets/product__ball-addon-options.liquid).
            // Professional Drilling is a Yes/No line item property (no price
            // change). Grips (Yes) adds 2x the Grip Add-On variant, Slug (Yes)
            // adds 1x the Slug Add-On variant, both as separate cart line items
            // so they can carry their own price via Shopify checkout.
            buildBallAddonItems(ballAddons) {
                const variantId = this.form.querySelector('[name="id"]')?.value;
                const quantityField = this.form.querySelector(
                    '[name="quantity"]'
                );
                const quantity = quantityField
                    ? parseInt(quantityField.value, 10) || 1
                    : 1;
                const drilling =
                    ballAddons.querySelector('[name="ball_drilling"]:checked')
                        ?.value || "No";
                const grips =
                    ballAddons.querySelector('[name="ball_grips"]:checked')
                        ?.value || "No";
                const slug =
                    ballAddons.querySelector('[name="ball_slug"]:checked')
                        ?.value || "No";
                const interchangeable =
                    ballAddons.querySelector('[name="ball_interchangeable"]:checked')
                        ?.value || "No";
                const interchangeableBrand =
                    ballAddons.querySelector('[name="ball_interchangeable_brand"]:checked')
                        ?.value || "";

                const items = [
                    {
                        id: variantId,
                        quantity: quantity,
                        properties: {
                            "Professional Drilling": drilling,
                        },
                    },
                ];

                const addons = window.mojoBallAddons || {};
                if (drilling === "Yes" && addons.drillingVariantId) {
                    items.push({
                        id: addons.drillingVariantId,
                        quantity: 1 * quantity,
                    });
                }
                if (grips === "Yes" && addons.gripVariantId) {
                    items.push({
                        id: addons.gripVariantId,
                        quantity: 2 * quantity,
                    });
                }
                if (slug === "Yes" && addons.slugVariantId) {
                    items.push({
                        id: addons.slugVariantId,
                        quantity: 1 * quantity,
                    });
                }
                if (interchangeable === "Yes" && addons.interchangeableVariantId) {
                    items.push({
                        id: addons.interchangeableVariantId,
                        quantity: 1 * quantity,
                        properties: {
                            "Brand": interchangeableBrand || "(not specified)",
                        },
                    });
                }

                return items;
            }

            async handleSubmitError(response) {
                const cart = document.querySelector("cart-sidebar");
                const itemCount = +cart?.querySelector?.(".cart-sidebar__total")
                    ?.dataset?.itemCount;
                const newCartJson = await this.getCartJson();

                this.handleErrorMessage(response.description);
                if (itemCount === newCartJson.item_count) return;

                await cart.reload();
                let line = 1;
                let variantId = [...this.form.elements].find(
                    (el) => el.name === "id"
                )?.value;
                if (variantId) {
                    newCartJson.items?.forEach?.((item, index) => {
                        if (item.variant_id === +variantId) line = index + 1;
                    });
                }

                cart.revealStickyHeaderAndOpen() || cart.open();
            }

            async onSubmitHandler(evt) {
                const cart = document.querySelector("cart-sidebar");

                if (!cart) {
                    return;
                }

                evt.preventDefault();
                const submitButton = this.getSubmitButton();
                if (submitButton.classList.contains("loading")) return;

                this.handleErrorMessage();

                if (!submitButton.querySelector(".loading-overlay"))
                    submitButton.prepend(
                        createFromTemplate("template-loading-overlay")
                    );

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");

                cart.setActiveElement &&
                    cart.setActiveElement(document.activeElement);

                const ballAddons = this.querySelector("[data-ball-addons]");

                try {
                    let response, jsonResponse;

                    if (ballAddons) {
                        // Bowling Balls product page: submit main variant plus
                        // any selected grip/slug add-on line items together.
                        const items = this.buildBallAddonItems(ballAddons);

                        response = await fetch(`${routes.cart_add_url}`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                                Accept: "application/json",
                            },
                            body: JSON.stringify({
                                items: items,
                                sections: cart
                                    .getSectionsToRender()
                                    .map((section) => section.id),
                                sections_url: window.location.pathname,
                            }),
                        });
                        jsonResponse = await response.json();
                    } else {
                        const config = fetchConfig("javascript");
                        config.headers["X-Requested-With"] = "XMLHttpRequest";
                        delete config.headers["Content-Type"];

                        const formData = new FormData(this.form);
                        formData.append(
                            "sections",
                            cart
                                .getSectionsToRender()
                                .map((section) => section.id)
                        );

                        formData.append(
                            "sections_url",
                            window.location.pathname
                        );
                        config.body = formData;

                        response = await fetch(
                            `${routes.cart_add_url}`,
                            config
                        );
                        jsonResponse = await response.json();
                    }

                    if (!response.ok || jsonResponse.status) {
                        this.handleSubmitError(jsonResponse);
                        return;
                    }

                    if (cart && jsonResponse.sections) {
                        cart.renderContents(jsonResponse);
                    } else {
                        window.location.reload();
                    }

                    // cartSidebar && cartSidebar.triggerCartSidebarOnSubmit(response);
                    // hide gift card recipient form on submit
                    if (this.recipientForm)
                        this.hideRecipientForm(this.recipientForm);

                    // hide quickView popup on submit
                    document
                        .querySelector("#PopupModal-quickView")
                        ?.removeAttribute?.("open");
                } catch (error) {
                    console.error("Error submitting form:", error);
                } finally {
                    submitButton.classList.remove("loading");
                    submitButton.removeAttribute("aria-disabled");
                }
            }

            hideRecipientForm(recipientForm) {
                const input = recipientForm.querySelector("input");
                const fields = recipientForm.querySelector(".recipient-fields");

                if (input.checked) {
                    let animation = fields.animate(
                        { height: [fields.clientHeight + "px", "0"] },
                        { duration: 300, easing: "linear" }
                    );

                    input.checked = false;
                    animation.onfinish = () => {
                        fields.style.height = "0";
                    };
                }
            }

            handleErrorMessage(errorMessage = false) {
                const messageWrapper = this.getMessageWrapper();

                // gift-card recipient form error messages
                if (
                    errorMessage.email ||
                    errorMessage.send_on ||
                    errorMessage.message
                )
                    errorMessage =
                        errorMessage.email ||
                        errorMessage.send_on ||
                        errorMessage.message;

                this.errorMessage =
                    this.errorMessage ||
                    messageWrapper.querySelector(".error-message");
                this.errorMessage.textContent = errorMessage || "";
                if (errorMessage) messageWrapper.removeAttribute("hidden");
                else messageWrapper.setAttribute("hidden", true);
            }
        }
    );
}
